import Vue from 'vue';
import get from 'lodash.get';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    el,
    data: () => ({
      showModal: false,
      video: null,
      videoIndex: 0,
    }),
    mounted() {
      this.initVideos();
    },
    computed: {
      videoId() {
        return get(this.video, 'id', '');
      },
      videoTitle() {
        return get(this.video, 'title', '');
      },
      embedSrc() {
        return `https://www.youtube.com/embed/${this.videoId}?rel=1&enablejsapi=1`;
      },
    },
    methods: {
      initVideos() {
        const videoJsonStr = el.dataset.videoJson;
        this.video = JSON.parse(videoJsonStr);
      },
      openModal(videoIndex) {
        this.videoIndex = videoIndex;

        this.showModal = true;

        this.$nextTick(() => {
          if (this.$refs.videoModal) {
            disableBodyScroll(this.$refs.videoModal);
          }
        });
      },
      closeModal() {
        this.showModal = false;
        clearAllBodyScrollLocks();
      },
    },
  });
